import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ScrollUp from '../components/ScrollUp';
import VideoLanding from '../pages/VideoLanding';
import Home from '../pages/Home';
import NotFound from '../pages/NotFound';
import OCLive from '../pages/OCLive';
import OCLiveStream from '../pages/OCLiveStream';
import SearchLanding from '../pages/SearchLanding';
import WebinarsLanding from '../pages/WebinarsLanding';
import ViewAllLanding from '../pages/ViewAllLanding';
import PrivateRoute from './PrivateRoute';
import VideosViewAllLanding from '../pages/VideosViewAllLanding';
import AnalyticsLanding from '../pages/AnalyticsLanding';
import VerifyEmail from '../pages/profile/VerifyEmail';
import EmailConfirmation from '../pages/EmailConfirmation';
import Profile from '../pages/profile';
import CmeLanding from '../pages/cme';
import ModeratorAdmin from "../pages/moderator/admin";

function AppRoutings({showHeader}) {
  return (
    <Router>
      <Header showHeader={showHeader} />
      <ScrollUp />
      <main id='main'>
        <Switch>
          <Route exact path='/' component={Home} />
          <Route exact path='/live/:webinarId' component={() => <OCLive isCMEWebinar={true} />} />
          <Route exact path={`/stream/:youtubeId/:chapterId`} component={() => <OCLiveStream isCMEWebinar={true} />} />
          <Route exact path={`/derma-live`} component={() => <OCLive isCMEWebinar={true} chapterIdProps={7749} />} />
          <Route path={['/academics/:courseSlug/:moduleId/:chapterId', '/academics/:courseSlug/:chapterId', '/academics/:courseSlug']} component={VideoLanding} />
          <Route path='/search/:query' component={SearchLanding} />
          <Route path='/user/confirm' component={EmailConfirmation} />
          <Route path='/verifyEmail' component={VerifyEmail} />
          <Route exact path='/:orgId/:sectionId/:sectionName' component={VideosViewAllLanding} />
          <Route path='/analytics' component={AnalyticsLanding} />
          <Route path='/cme' component={CmeLanding} />
          <PrivateRoute path='/webinars' component={WebinarsLanding} />
          <PrivateRoute path='/viewAll' component={ViewAllLanding} />
          <PrivateRoute path='/profile' component={Profile} />
          <Route exact path="/moderator-admin/:projectId" component={ModeratorAdmin}/>
          <Route path='*' component={NotFound} />
        </Switch>
      </main>
      {showHeader ? <Footer /> : ''}
    </Router>
  );
}

export default AppRoutings;
